module.exports = __webpack_public_path__ + "img/peixun.498a45cd.498a45cd.jpg";